import { StyleSheet as PDFStyleSheet } from '@react-pdf/renderer'

const styles = PDFStyleSheet.create({
  mainDiv: {
    width: '100%',
    paddingLeft: '5%',
    paddingRight: '5%',
    borderBottomWidth: 1,
    borderStyle: 'solid',
    borderColor: '#dbdbdb'
  },
  content: {
    width: '100%',
    flexDirection: 'row'
  },
  subjectTitle: {
    fontSize: 9,
    color: 'black',
    marginRight: 2
  },
  subjectValue: {
    fontWeight: 'bold',
    fontSize: 8,
    color: 'black'
  },
  subject1: {
    width: '60%',
    marginBottom: 4
  },
  subject2: {
    width: '40%',
    marginBottom: 4
  },
  rowDirection: {
    flexDirection: 'row'
  },
  refundRow: {
    marginTop: 4
  }
})
export default styles
